import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const FilesPdfIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M21.53 4.47L17.53 0.47C17.39 0.33 17.2 0.25 17 0.25H4C3.04 0.25 2.25 1.04 2.25 2V22C2.25 22.96 3.04 23.75 4 23.75H20C20.96 23.75 21.75 22.96 21.75 22V5C21.75 4.8 21.67 4.61 21.53 4.47ZM20.25 22C20.25 22.14 20.14 22.25 20 22.25H4C3.86 22.25 3.75 22.14 3.75 22V2C3.75 1.86 3.86 1.75 4 1.75H16.69L20.25 5.31V22Z"
        fill={color}
      />
      <path
        d="M7.93 14.11H5.62V19H6.68V17.24H7.93C8.84 17.24 9.41 16.6 9.41 15.68C9.41 14.76 8.84 14.12 7.93 14.12V14.11ZM8.31 15.83C8.31 16.15 8.11 16.31 7.8 16.31H6.68V15.04H7.8C8.11 15.04 8.31 15.21 8.31 15.52V15.83Z"
        fill={color}
      />
      <path
        d="M12.19 14.11H10.35V19H12.19C13.48 19 14.34 18.18 14.34 16.56C14.34 14.94 13.49 14.12 12.19 14.12V14.11ZM13.21 16.93C13.21 17.71 12.82 18.05 12.19 18.05H11.41V15.05H12.19C12.82 15.05 13.21 15.39 13.21 16.17V16.93Z"
        fill={color}
      />
      <path
        d="M15.37 19H16.43V17H18.29V16.06H16.43V15.06H18.61V14.11H15.37V19Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

FilesPdfIcon.displayName = 'FilesPdfIcon';
